import { createI18n } from 'vue-i18n';

/* Import translations */
import en from '@/i18n/locales/en.json';
import nl from '@/i18n/locales/nl.json';
import de from '@/i18n/locales/de.json';
import fr from '@/i18n/locales/fr.json';
import { Locale } from '../localeConfig';

/* Import stores */
import { useAuthStore } from '@/stores/auth';
import { useOnlineStore } from '@/stores/online';
import { useLaundryStore } from '@/stores/laundry';
import { useWebportalStore } from '@/stores/webportal';

//Create i18n instance
const i18nInstance = createI18n({
    globalInjection: true,
    legacy: false,
    locale: Locale.locale,
    messages: {
        'en-GB': en,
        'nl-NL': nl,
        'de-DE': de,
        'fr-FR': fr,
    },
    availableLocales:['en-GB', 'nl-NL', 'de-DE', 'fr-FR']
  });

export default i18nInstance;

export const i18n = i18nInstance.global;

export const updateTranslations = () => {
  const authStore = useAuthStore();
  const onlineStore = useOnlineStore();
  const laundryStore = useLaundryStore();
  const webportalStore = useWebportalStore();

  if (onlineStore.online && authStore.VLtoken && webportalStore.selectedWebportal) {
    laundryStore.getKlant().finally(() => {
      const dragersBewoners = laundryStore.klant.kastVakDrager === false ? 'Bewoners' : 'dragers';
      const dragerBewoner = laundryStore.klant.kastVakDrager === false ? 'Bewoner' : 'drager';
      i18nInstance.global.availableLocales.forEach((l: any) => {
        const t = i18nInstance.global.getLocaleMessage(l)
        t["dragersOfBewoners"] = t[dragersBewoners]
        t["dragerOfBewoner"] = t[dragerBewoner]
        t["nav"]["dragersOfBewoners"] = t[dragersBewoners]
        t["nav"]["dragerOfBewoner"] = t[dragerBewoner]
        i18nInstance.global.setLocaleMessage(l, t);
      })
    })
  }
}